AuthRoute = require 'mixins/authenticated-route'

App.ClientTagsRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    @store.filter('client-tag', params, -> true)
  actions:
    goBackToClientTagsList: ->
      @transitionTo 'client-tags'
      false
